import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HeaderAction.css';

const HeaderAction = ({title, activeButton=''}) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (activeButton === 'cabinet') {
            navigate('/', {state: {isCabinet: true}});
        } else if (activeButton === 'shop') {
            navigate('/');
        } else {
            navigate(-1);
        }
    }

    return (
        <header className="info-header">
            <div className="header-background"></div>
            <button className="back-button" onClick={handleBack}>
                <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_898_107)">
                        <path d="M17.0003 1.16663C23.6947 1.16663 29.185 6.29296 29.7753 12.8333H19.3337V9.33329C19.3337 8.86196 19.049 8.43613 18.6138 8.25529C18.1775 8.07446 17.6758 8.17479 17.3422 8.50846L12.6755 13.1751C12.2193 13.6313 12.2193 14.3686 12.6755 14.8248L17.3422 19.4915C17.6758 19.8251 18.1775 19.9255 18.6138 19.7446C19.049 19.5638 19.3337 19.138 19.3337 18.6666V15.1666H29.7753C29.185 21.707 23.6947 26.8333 17.0003 26.8333C9.91283 26.8333 4.16699 21.0875 4.16699 14C4.16699 6.91246 9.91283 1.16663 17.0003 1.16663Z" fill="#FFC300" />
                    </g>
                    <defs>
                        <filter id="filter0_d_898_107" x="-1" y="0" width="36" height="36" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_898_107" />
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_898_107" result="shape" />
                        </filter>
                    </defs>
                </svg>
            </button>
            <h1 className="info-title">{title}</h1>
        </header>
    );
};

export default HeaderAction;
